<template>
  <div>
    <common-dialog ref="dialog" width="1000px" show-save-button unit="其他应付单" edit-title id-key="RegionId" :data="data"
      :line-form="true" form-label-width="85px" :form-rules="rules" :save-func="api.save" :before-save="onBeforeSave"
      @opened="onOpened" @edit-opened="onEditOpened" @closed="onClosed" @close-saved="$emit('close-saved')">
      <template slot="form">
        <div class="row-head">基本信息</div>
        <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item label="单据编号" prop="Name">
                <el-input v-model="data.Name" placeholder="请输入区域名称" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="单据日期" prop="date">
                <el-date-picker v-model="data.Date" type="date" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="业务类型" prop="date">
               <business-select
                  v-model="data.BusinessTypeId"
                  :params="{Kind:'应收',SourceType:'收入单'}"
                  @change="onChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="往来单位" prop="date">
                <select-input
                  placeholder="请选择单位"
                  :label="data.TradeUnitName"
                  v-model="data.TradeUnitId"
                  @click="openTradeunit"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="付款到期日" prop="date">
                <el-date-picker v-model="data.date" type="date" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="经办人" prop="date">
                <select-input
                  placeholder="请选择经办人"
                  :label="data.ClerkName"
                  v-model="data.ClerkId"
                  @click="openEmp"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="date">
                <el-input type="textarea" v-model="data.remark" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>

        <div class="row-tb-head" style="margin-top: 10px">
          <span>单据明细</span>
          <div style="float: right">
            <el-button type="primary" @click="add">添加</el-button>
            <!-- <el-button type="danger" @click="del">删除</el-button> -->
          </div>
        </div>
        <el-table ref="table" class="table-line tb-c-head" @selection-change="handleSelectionChange" :data="areaList"
          border>
          <!-- <el-table-column type="selection" width="55" /> -->
          <el-table-column prop="Name" label="摘要" min-width="210" align="center">
            <template slot-scope="{row}">
              <el-input type="text" v-model="row.title"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="Name" label="项目" min-width="110" align="center">
            <template slot-scope="{row}">
              <el-select v-model="row.project">
                <el-option :value="0" label="项目1"></el-option>
                <el-option :value="1" label="项目2"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="Name" label="金额" min-width="110" align="center">
            <template slot-scope="{row}">
              <el-input type="number" v-int v-model="row.mount"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="操作" min-width="110" align="center">
            <template slot-scope="{ row, $index }">
              <el-button type="text" @click="del(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </common-dialog>
    <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <area-dialog ref="areaDialog" in-dialog selectable multiple @select-multiple="setArea"></area-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
import areaDialog from "@/components/basedata/basedoc/district/listDialog";
import businessSelect from "@/components/basedata/basedoc/business/select";
import empDialog from "@/components/personnel/result/record/listDialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    areaDialog,
    businessSelect,
    empDialog,
    tradeunitDialog
  },
  data() {
    return {
      data: {
        RegionId: 0,
        UserName: this.$commonJs.userName,
        Date: new Date(),
        Name: "",
        unit: "",
        date: "",
        DetailDtos: [],
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/region").default,
      // trendData: iForm.Data,
      showList: [],
      areaList: [],
      multipleSelection: [],
      rules: {
        Name: [{ required: true, message: "区域名称不能为空" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      console.log(this.$commonJs.getDay);
    },

    onEditOpened(data) {
      this.api.info(this.data.RegionId).then((res) => {
        this.areaList = res.Data.DetailDtos.reduce((arr, item) => {
          arr.push({ RegionId: item.RegionId, Name: item.Name });
          return arr;
        }, []);
        this.data = res.Data;
      });
    },
    setArea(data) {
      // console.log(emp);
      let areaId = this.areaList.map((item) => item.DistrictId);
      data.forEach((item) => {
        if (!areaId.includes(item.DistrictId))
          this.areaList.push({
            DistrictId: item.DistrictId,
            Name: item.Name,
            T: 0,
          });
      });
    },
     openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
     openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
    },
     onChange(data) {
      if (data) this.data.NeedTradeUnit = data.NeedTradeUnit;
      else this.data.NeedTradeUnit = true;
      this.$refs.dialog.clearValidate();
    },
    onBeforeSave() {
      // this.$message.warning("每个员工只能加入一个班组,该功能后续完善");
      if (this.data.DetailDtos.length == 0)
        return (this.data.DetailDtos = this.areaList);
      let delIds = this.areaList.map((item) => item.DistrictId);
      let delList = this.data.DetailDtos.reduce((arr, item) => {
        if (!delIds.includes(item.DistrictId)) arr.push({ ...item, T: 2 });
        return arr;
      }, []);

      let addIds = this.data.DetailDtos.map((item) => item.DistrictId);
      let addList = [];
      addList = this.areaList.reduce((arr, item) => {
        if (!addIds.includes(item.DistrictId)) arr.push({ ...item, T: 0 });
        return arr;
      }, []);

      this.data.DetailDtos = [...addList, ...delList];
      // console.log( this.data.DetailDtos);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    add() {
      this.areaList.push({
        title: "",
        project: null,
        mount: ""
      })
      // this.$refs.areaDialog.open().then((that) => that.getData());
    },
    del(data, index) {
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.areaList.splice(index, 1);
        })
        .catch(() => { });
    },
    onClosed() {
      this.showList = [];
      this.multipleSelection = [];
      this.areaList = [];
      this.data.DetailDtos = [];
    },
  },
};
</script>